import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from "./components/NavBar";
import Home from "./components/Home";
import Contact from "./components/Contact";
import About from "./components/About";
import Focus from "./components/Focus";
import Cause from "./components/Cause";
import Testimonials from "./components/Testimonials";
import Project from "./components/Project";
import History from "./components/History";
import Contact2 from './components/Contact2';
import Causes from './components/Causes';
// import Governance from './components/Governance';
import "./App.css";
import Homeproject from './components/Homeproject';

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <div>
              <Navbar />
              <Home />
              <About />
              <Focus />
              <Homeproject />
              <Cause />
              <Testimonials />
              <Contact />
            </div>
          }
        />
        {/* <Route
          path="/about"
          element={
            <div>
              <Navbar />
              <About />
              <Contact />
            </div>
          }
        /> */}
         <Route path="/history" element={<History />} />
        <Route path="/project" element={<Project />} />
        {/* <Route path="/governance" element={<Governance />} /> */}
        <Route path="/contact2" element={<Contact2 />} />
        <Route path="/causes" element={<Causes />} />
      </Routes>
    </Router>
  );
}

export default App;
